import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Formik, Form } from 'formik';
import { Autocomplete, Checkbox, Container, FormControlLabel, IconButton, TextField, TextareaAutosize } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { sorunTipi, aksiyonSahibi } from '../../helpers/ProcessData';
import Textarea from '@mui/joy/Textarea';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState, useEffect } from 'react';
import { uygunsuzlukTipi } from "../../helpers/ProcessData"
import { useSelector } from "react-redux"
import useArge from '../../hooks/useArge';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,

};

const ReaktifModal = ({ open, handleClose, info, setInfo,materialCode }) => {

  const [search, setSearch] = useState(null)
  const nowData = new Date()
  const currentdatetime = nowData.getDate() + "-" + (nowData.getMonth() + 1) + "-" + nowData.getFullYear()
  const currentTime = nowData.getHours() + ":" + nowData.getMinutes()
  const [isCheck, setIsCheck] = useState(false)

  const handleChange = (e, newValue, fieldName) => {
    // setInfo({ ...info, [e.target.name]: e.target.value,['urun_kodu']:search ? search.MALZEMEKODU : ""  })
    
    // Autocomplete'ten gelen olaylar için
    if (fieldName) {
      setInfo(prevInfo => ({
        ...prevInfo,
        [fieldName]: newValue?.MALZEMEKODU || ""
      }));
    }
    // TextField'tan gelen olaylar için
    else if (e?.target) {
      const { name, value } = e.target;
      // setInfo(prevInfo => ({
      //   ...prevInfo,
      //   [name]: value
      // }));
     
      setInfo(prevInfo => {

        const newInfo = { ...prevInfo, [name]: value }

        if (isCheck && newInfo.oldData_date) {

          const dateStr = newInfo.oldData_date.split('T')
          const parts = dateStr[0].split('-')
          newInfo.date = `${parts[2]}-${parts[1]}-${parts[0]}`
          newInfo.time = dateStr[1]
        }
        else {

          newInfo.date = currentdatetime.toString()
          newInfo.time = currentTime.toString()
        }
        return newInfo
      })
    }
  }

  const { getFireData, putFireData, postFireData } = useArge()


  const handleSubmit = (e) => {

    e.preventDefault()

    if (info.id) {
      putFireData('Reaktif', info)
      getFireData("Reaktif")
    }
    else {
      postFireData("Reaktif", info)
      getFireData("Reaktif")
    }

    handleClose()

  }


    // checkbox fonksiyon
    const handleIsCheck = (e) => {
      const { checked } = e.target
      setIsCheck(checked)
    }
  
    // checkbox false yap ve date bilgisini temizle
    function handleIsCheck_Reset() {
      setIsCheck(false)
      setInfo({ ...info, ['oldData_date']: "" })
    }

    

  return (
    <div>

      <Modal
        keepMounted
        open={open}
        onClose={() => {
          handleClose()
          handleIsCheck_Reset()
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography id="keep-mounted-modal-title" variant="h6" component="h2" color="#000000">
              Reaktif
            </Typography>

            <IconButton onClick={() => {
              handleClose()
              handleIsCheck_Reset()
            }}>
              <HighlightOffIcon sx={{ color: '#C70039', fontSize: '28px' }} />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox checked={isCheck} onChange={handleIsCheck} name="oldData" />
              }
              label="Geçmiş tarihli veri girişi"
            />
            {
              isCheck && <TextField
                name='oldData_date'
                id='oldData_date'
                type='datetime-local'
                onChange={handleChange}
              />
            }

          </Box>


          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2, overflow: 'scroll', maxHeight: '550px' }} component='form' onSubmit={handleSubmit}>

            <Autocomplete
              fullWidth
              value={search}
              name='urun_kodu'
              onChange={(event, newValue) => {
                setSearch(newValue);
                handleChange(event, newValue, 'urun_kodu')
              }}
              id="search-select-demo"
              options={materialCode}
              getOptionLabel={(option) => option.MALZEMEKODU}
              // style={{ width: 300 }}
              renderInput={(params) => <TextField {...params} label="Ürün Kodu" />}
            />


            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>


              <TextField
                fullWidth
                label="Boya Şarj No"
                name="boyasarjno"
                id="boyasarjno"
                type="text"
                variant="outlined"
                value={info.boyasarjno}
                onChange={handleChange}
              />


              <TextField
                fullWidth
                label="Boya Yoğunluk"
                name="boyayogunluk"
                id="boyayogunluk"
                type="text"
                variant="outlined"
                value={info.boyayogunluk}
                onChange={handleChange}
              />

              <TextField
                fullWidth
                label="Boya Miktarı"
                name="boyamiktari"
                id="boyamiktari"
                type="text"
                variant="outlined"
                value={info.boyamiktari}
                onChange={handleChange}
              />
            </Box>


            <TextField
              fullWidth
              label="Astarlama Yapan Kişi"
              name="astarlamayapankisi"
              id="astarlamayapankisi"
              type="text"
              variant="outlined"
              value={info.astarlamayapankisi}
              onChange={handleChange}
            />

            <FormControl fullWidth>
              <InputLabel id="redkabul">Red/Kabul/Şartlı Kabul</InputLabel>
              <Select
                labelId="redkabul"
                id="redkabul"
                name='redkabul'
                label="redkabul"
                value={info.redkabul}
                onChange={handleChange}
              >
                <MenuItem value="RED">RED</MenuItem>
                <MenuItem value="KABUL">KABUL</MenuItem>
                <MenuItem value="ŞARTLI KABUL">ŞARTLI KABUL</MenuItem>
              </Select>
            </FormControl>



            <TextField
              multiline
              fullWidth
              label="Açıklama"
              name="aciklama"
              id="aciklama"
              type="text"
              variant="outlined"
              value={info.aciklama}
              onChange={handleChange}
            />

            <Button
              variant='contained'
              fullWidth
              type='submit'
            >
              {info?.id ? "Update Data" : "Add New Data"}
            </Button>


          </Box>


        </Box>
      </Modal>
    </div>
  );
}

export default ReaktifModal